import React from "react";
import transition from "../transition";

function About() {
  return <div>This is About</div>;
}

export default transition(About)
